// ─────────────────────────────────────────────────────────────────────────────
// 站间导航 —— 与博客站（blog.xhja.cn）顶部那一排完全一致。
//
// 显示文字与链接指向都取自博客站**真实菜单**（2026-09-21 从线上 header 抓取）：
//     首页 / 文章 / 碎碎念 / 相册 / 留言板 / 友链 / 关于
// 其中「文章」在博客上带二级菜单（技术笔记 / 随笔），这里照做。
//
// ⚠️ 链接一律写成**绝对地址**：相册站是独立站点，写成 `/archives` 会跑到
//    pics.xhja.cn/archives 去，那个页面并不存在。
// ⚠️ 博客那边改了菜单，只改这个文件即可，不要去动组件。
// ─────────────────────────────────────────────────────────────────────────────

// 博客站主域名。要整体换域只改这一行（blog.xhja.cn 与 xhj.ink 是同一个 Halo）。
export const BLOG_BASE = 'https://blog.xhja.cn'

export interface NavChild {
  label: string
  href: string
}

export interface NavItem {
  label: string
  href: string
  children?: NavChild[]
}

export const SITE_NAV: NavItem[] = [
  { label: '首页', href: `${BLOG_BASE}/` },
  {
    label: '文章',
    href: `${BLOG_BASE}/archives`,
    children: [
      { label: '技术笔记', href: `${BLOG_BASE}/categories/tech` },
      { label: '随笔', href: `${BLOG_BASE}/categories/essay` },
    ],
  },
  { label: '碎碎念', href: `${BLOG_BASE}/moments` },
  { label: '相册', href: `${BLOG_BASE}/photos` },
  { label: '留言板', href: `${BLOG_BASE}/guestbook` },
  { label: '友链', href: `${BLOG_BASE}/links` },
  { label: '关于', href: `${BLOG_BASE}/about` },
]
